import { LoadingSpinner } from '../../components/loadingSpinner';
import { type FC, type ReactNode } from 'react';
import { StyledButton } from './styled';

export interface ButtonProps {
  label: string;
  onClick?: () => void | Promise<void>;
  type?: 'button' | 'submit' | 'reset' | undefined;
  className?: string;
  variant?: 'primary' | 'secondary' | 'gray' | 'tertiary';
  size?: 'normal' | 'large';
  isLoading?: boolean;
  shadowBox?: boolean;
  minWidth?: string;
  disabled?: boolean;
  icon?: ReactNode;
}

const Button: FC<ButtonProps> = ({
  label,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'normal',
  minWidth = '140',
  className,
  isLoading,
  icon,
  ...props
}) => {
  return (
    <StyledButton
      style={{ minWidth: `${minWidth}px` }}
      type={type}
      onClick={onClick}
      className={`flex items-center justify-center gap-2 ${className ?? ''}`}
      $variant={variant}
      $size={size}
      disabled={isLoading}
      role="button"
      {...props}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {icon}
          {label}
        </>
      )}
    </StyledButton>
  );
};
export default Button;
